<template>
  <div class="map-wrapper">
    <div v-if="loading" class="progress">
      <v-progress-circular
        indeterminate
        color="white"
      />
    </div>
    <v-btn
      v-show="showExelBtn"
      class="exel-btn"
      @click="getExcel"
    >
      get excel
    </v-btn>
    <div id="map" />
    <template v-if="map">
      <context-menu
        v-if="showMenu"
        v-model="showMenu"
        :map="map"
        :x="menuOptions.x"
        :y="menuOptions.y"
      />
      <Drawer v-model="tab" class="mr-2">
        <template v-slot:default>
          <keep-alive>
            <component
              v-bind:is="tab"
              :map="map"
              @showExelBtn="showExelBtnMethod"
            />
          </keep-alive>
        </template>
      </Drawer>
    </template>
    <Teleport to="#map">
      <image-dialog
        v-if="imageDialogOpen"
        :src="selectedImagePath"
        @close="closeImageModal"
      />
    </Teleport>
  </div>
</template>

<script>
import L from '../plugins/updated-leaflet';
import Teleport from 'vue2-teleport'
import Drawer from '../components/map/drawer';
import multimapMenu from '../plugins/leaflet-controls/multimap-menu'
import ImageDialog from '../components/map-dialogs/ImageDialog.vue'
export default {
  components: {
    Drawer,
    ContextMenu: () => import('@/components/map/mapContextmenu'),
    Runtime: () => import('@/components/map/runtime'),
    Editor: () => import('@/components/map/editor'),
    RuntimeMarkers: () => import('@/components/map/runtimeMarkers'),
    Telemetry: () => import('@/components/map/telemetry'),
    Teleport,
    ImageDialog
  },
  data() {
    const tab = this.$route.query.tab || 'runtime'
    const currentMap = this.$route.query.map_name || null
    const currentMapId = this.$route.query.map_id || null
    const currentType = this.$route.query.map_type || null
    return {
      imageDialogOpen: false,
      selectedImagePath: null,
      url: null,
      map: null,
      lastZoom: 1,
      tab,
      showExelBtn: false,
      showMenu: false,
      mapOptions: {
        minZoom: -4,
        maxZoom: 4,
        doubleClickZoom: false,
        zoomControl: false,
        currentMap,
        currentType,
        currentMapId
      },
      menuOptions: {
        x: -128,
        y: 128
      },
      idForExelData: null,
      excelName: null,
      loading: false
    }
  },
  async mounted () {
    const southWest = L.latLng(-256, 0),
      northEast = L.latLng(0, 256),
      bounds = L.latLngBounds(southWest, northEast);

    this.map = L.map('map', {
      ...this.mapOptions,
      crs: L.CRS.Simple
    }).setView([-128,128], 1);

    this.$eventBus.$on('loading', (result) => {
      this.loading = result
    })

    this.$eventBus.$on('open-image-dialog', (path) => {
      this.selectedImagePath = path
      this.imageDialogOpen = true
    })

    this.$eventBus.$on('close-image-dialog', this.closeImageModal)

    if (this.isMultiLevels) {
      const menu = new multimapMenu({ id: 'multimap-menu', vue: this })
      menu.addTo(this.map)
    } else {
      const tileLayer = L.tileLayer(this.$store.getters.projectPath + '/map/images/{z}/{x}x{y}.png', {
        bounds
      });

      tileLayer.addTo(this.map);
    }

    this.map.on('contextmenu', (event) => {
      this.menuOptions.x = event.containerPoint.x
      this.menuOptions.y = event.containerPoint.y + 48
      this.$nextTick(() => {
        this.showMenu = true
      })
    })

    this.map.on('zoomend', () => {
      let zoom = this.map.getZoom();
      if (zoom < 1 && this.lastZoom >= 1) {
        this.map.eachLayer((l) => {
          if (l.getTooltip) {
            let toolTip = l.getTooltip();
            const zoomOff = l.feature && l.feature.properties.zoomOff
            if (toolTip && !zoomOff) {
              this.map.closeTooltip(toolTip);
            }
          }
        });
      } else if (zoom >= 1 && this.lastZoom < 1) {
        this.map.eachLayer((l) => {
          if (l.getTooltip) {
            let toolTip = l.getTooltip();
            const zoomOff = l.feature && l.feature.properties.zoomOff
            if (toolTip && !zoomOff) {
              this.map.addLayer(toolTip);
            }
          }
        });
      }
      this.lastZoom = zoom;
    })
  },
  computed: {
    isMultiLevels () {
      return this.$store.state.project_config.world === 'multi-levels'
    }
  },
  watch: {
    tab () {
      this.updateRouterQuery()
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('loading')
    this.$eventBus.$off('open-image-dialog')
    this.$eventBus.$off('close-image-dialog')

    this.map.remove()
  },
  methods: {
    showExelBtnMethod(show, id, name) {
      this.idForExelData = id
      this.showExelBtn = show
      this.excelName = name
    },
    async getExcel() {
      const data = await this.$axios.get(this.$store.getters.projectPath + '/map/discuitilization/excel/' + this.idForExelData, {
        responseType: 'blob'
      })
      const blob = new Blob([ data.data ], { type: 'application/xlsx' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = this.excelName;
      link.click();
    },
    closeImageModal () {
      this.imageDialogOpen = false
      this.selectedImagePath = null
    },
    updateRouterQuery () {
      const flag = !(
        this.$route.query.tab === this.tab
      )

      if (flag) {
        this.$router.replace({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            tab: this.tab
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.map-wrapper {
  height: 100%;
  position: relative;
}

.map-wrapper #map {
  height: 100%;
}

.map-wrapper .progress {
  top: 10px;
  left: 50%;
  z-index: 999;
  transform: translateX(-50%);
  position: absolute;
}
.map-wrapper .exel-btn {
  position: absolute;
  top: 10px;
  left: 422px;
  z-index: 999;
}

.map-wrapper >>> .tooltip-inside-figure {
  color: white;
  background-color: transparent;
  border: none;
  box-shadow: none;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
}

.map-wrapper >>> .v-slide-group__next, .map-wrapper >>> .v-slide-group__prev {
  min-width: 32px;
  width: 32px;
  flex: 0 1 32px;
}

.leaflet-container {
  background-color:black !important;
}

#map >>> .leaflet-center {
  left: 50%;
  transform: translate(-50%, 0%);
}

.leaflet-container.leaflet-shift {
  cursor: crosshair;
}

.leaflet-container.select-points {
  cursor: default;
}

.leaflet-container.leaflet-shift.leaflet-grab {
  cursor: crosshair;
}

#map >>> .bad {
  color: #FF9100;
}

#map >>> .leaflet-control {
  max-width: 400px;
}

#map >>> .bad.icon::before {
  content: "\25bc\0020+"
}

#map >>> .bad.icon-inverse::before {
  content: "\25bc\0020"
}

#map >>> .good {
  color: #00E676;
}

#map >>> .bad.icon::before {
  content: "\25b2\0020"
}

#map >>> .bad.icon-inverse::before {
  content: "\25b2\0020+"
}

#map >>> .v-data-table {
  max-width: 400px;
  width: 400px;
}

#map >>> .v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
#map >>> .v-data-table > .v-data-table__wrapper > table > thead > tr > td,
#map >>> .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
  font-size: inherit;
  height: auto;
}

#map >>> .v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
#map >>>  .v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
#map >>>  .v-data-table > .v-data-table__wrapper > table > thead > tr > td,
#map >>>  .v-data-table > .v-data-table__wrapper > table > thead > tr > th,
#map >>>  .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td,
#map >>>  .v-data-table > .v-data-table__wrapper > table > tfoot > tr > th {
  padding: 0 4px;
}

#map >>> .v-data-table > .v-data-table__wrapper > table > tbody > tr > td > .word-break,
#map >>>  .v-data-table > .v-data-table__wrapper > table > tbody > tr > th > .word-break {
  word-break: break-all;
}

#map >>> .big-row {
  word-wrap: break-word;
  border-bottom: 1px solid #dfdfdf;
}

#map >>> .big-row:last-of-type {
  border-bottom: none;
}

#map >>> .multimap-menu .v-speed-dial--direction-right .v-speed-dial__list {
  flex-direction: column;
}

#map >>> .multimap-menu .v-speed-dial--direction-left .v-speed-dial__list,
#map >>> .multimap-menu .v-speed-dial--direction-right .v-speed-dial__list {
  height: auto;
}
#map >>> .multimap-menu .v-speed-dial__list {
  align-items: start;
}

#map >>> .cross-point,
#map >>> .record-circle-outline-point,
#map >>> .chevron-up-circle-outline-point {
  width: 32px;
  height: 32px;
}

#map >>> .record-circle-outline-point,
#map >>> .chevron-up-circle-outline-point {
  width: 32px;
  height: 32px;
  cursor: context-menu;
}

#map >>> .cross-point::before,
#map >>> .record-circle-outline-point::before,
#map >>> .chevron-up-circle-outline-point::before,
#map >>> .player-marker::before,
#map >>> .enemy-marker::before {
  content:"";
  display:block;
  background-color: var(--pseudo-backgroundcolor);
  mask-size: cover;
  height: 100%;
}

#map >>> .cross-point::before {
  mask-image: url(../assets/cross.svg);
}

#map >>> .record-circle-outline-point::before {
  mask-image: url(../assets/record-circle-outline.svg);
}

#map >>> .chevron-up-circle-outline-point::before {
  mask-image: url(../assets/chevron-up-circle-outline.svg);
}

#map >>> .player-marker::before {
  mask-image: url(../assets/map-marker.svg);
}

#map >>> .enemy-marker::before {
  mask-image: url(../assets/enemy-marker.svg);
}

#map >>> .very-good-marker::before,
#map >>> .good-marker::before,
#map >>> .bad-marker::before,
#map >>> .very-bad-marker::before {
  content:"";
  display:block;
  mask-size: cover;
  height: 100%;
}

#map >>> .very-good-marker::before {
  mask-image: url(../assets/very-good.svg);
  background-color: #4CAF50;
}

#map >>> .good-marker::before {
  mask-image: url(../assets/good.svg);
  background-color: #FFEB3B;
}

#map >>> .bad-marker::before {
  mask-image: url(../assets/bad.svg);
  background-color: #FF9800;
}

#map >>> .very-bad-marker::before {
  mask-image: url(../assets/very-bad.svg);
  background-color: #F44336;
}

#map >>> .inactive::before {
  background-color: grey;
}

#map >>> .shadow {
  filter: drop-shadow(0px 0px 1px rgb(0 0 0 / 0.9));
}
</style>
